import { NgModule } from '@angular/core';

import { FetchImageFromHtmlPipe } from './fetch-image-from-html.pipe';



@NgModule({
  declarations: [FetchImageFromHtmlPipe],
  exports: [FetchImageFromHtmlPipe]
})
export class FetchImageFromHtmlModule { }
